module.exports = __webpack_public_path__ + "img/ClickForSound_6.7caa29d4.png";